import { captureMessage } from '@sentry/react';

export const supportsWebgl = () => {
  const canvas = document.querySelector('#webglContext') as HTMLCanvasElement | null;
  const context = canvas?.getContext('webgl') || canvas?.getContext('webgl2');

  if (!context) {
    captureMessage('WebGL is not supported.', (scope) => {
      scope.setExtra('canvas', canvas);
      return scope;
    });
  }

  return !!context;
};
